export default "__VITE_ASSET__COXy_Eu2__"